import React, { useState } from "react";

function LeerMas({ texto = "", limite = 120 }) {
  const [verMas, setVerMas] = useState(false);

  if (!texto) return <span>No aplica</span>;

  const textoMostrar = verMas ? texto : texto.substring(0, limite) + "…";

  return (
    <div
      style={{
        whiteSpace: "pre-wrap",
        textAlign: "justify", // ⬅️ TEXTO JUSTIFICADO
        lineHeight: "1.4",
      }}
    >
      {textoMostrar}

      {texto.length > limite && (
        <button
          onClick={() => setVerMas(!verMas)}
          style={{
            color: "#007bff",
            background: "none",
            border: "none",
            padding: 0,
            cursor: "pointer",
            fontSize: "13px",
            marginLeft: "4px",
          }}
        >
          {verMas ? "Leer menos" : "Leer más"}
        </button>
      )}
    </div>
  );
}

export default LeerMas;
